import { graphql } from '@/gql';

graphql(`
  fragment HomeServiceOrderChargeFragment on HomeServiceOrderChargeType {
    id
    homeServiceOrderId
    isDeposit
    chargeAmount
    gogoFee
    transactionId
    status
    description
    chargedBy
    isRecurringJob
    createdAt
    updatedAt
    transaction {
      id
      status
    }
    chargedByOperator {
      id
      firstName
      lastName
    }
  }
`);
